import { Injectable } from '@angular/core';
import { addDoc, collection, Firestore } from "@angular/fire/firestore";
import {EventService} from "./event.service";
import {AuthenticationService} from "./authentication.service";
import {OrganizationService} from "./organization.service";
import {Event} from "../models/event";
import {Organization} from "../models/organization";
import {User} from "../models/user";
import {switchMap} from "rxjs/operators";
import {forkJoin} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(
    private firestore: Firestore,
    private eventService: EventService,
    private orgService: OrganizationService,
    private authService: AuthenticationService
  ) { }

  /**
   * Sends an email based on the provided parameters.
   *
   * @param recipient
   * @param subject
   * @param body
   * @return uid
   */
  async sendEmail(recipient: string, subject: string, body: string): Promise<any> {
    await addDoc(collection(this.firestore, `mail`), {
      to: recipient,
      message: {
        subject,
        html: body,
        text: body
      }
    }).then(docRef => {
    }).catch(error => console.error(error));
  }

  /**
   * Sends two emails upon signing up for an activity, one to the user and one to the organization hosting the activity.
   *
   * @param eventID
   * @param userID
   */
  sendRegistrationEmail(eventID: string, userID: string) {
    let event: Event;
    let organization: Organization;
    let user: User;

    this.eventService.getEventByRef(eventID).pipe(
      switchMap(e => {
        event = e;
        return forkJoin([
          this.orgService.getOrganizationByRef(e.organization),
          this.authService.getUserDetails(userID)
        ]);
      })
    ).subscribe(([org, userDetails]) => {
      organization = org;
      user = userDetails.data as User;

      let emailSubjectOrg = `Nieuwe aanmelding: ${event.name}`;
      let emailBodyOrg =
        `Beste,
        <br><br>
        Er is een nieuwe aanmelding voor de activiteit: <a href='https://steddie.nl/activiteit/${event.id}'>${event.name}</a>.
        <br><br>
        Ga naar het <a href='https://steddie.nl/activiteit/details/${event.id}'>overzicht</a> om de contactgegevens van de aangemelde gebruikers te bekijken.
        <br><br>
        Met vriendelijke groet,
        <br>
        Het Steddie team`
      this.sendEmail(org.email, emailSubjectOrg, emailBodyOrg);

      let emailSubjectUser = `Je aanmelding is gelukt`;
      let emailBodyUser =
        `Beste ${user.name},
        <br><br>
        Je aanmelding voor de activiteit: <a href='https://steddie.nl/activiteit/${event.id}'>${event.name}</a> is gelukt!
        <br>
        Op de <a href="https://steddie.nl/profiel/activiteiten">profielpagina</a> kun je een overzicht terugvinden met daarin alle activiteiten waarvoor je bent aangemeld.
        <br>
        <br>
        De organisator van deze activiteit zal contact met je opnemen met daarin meer details over de activiteit.
        <br>
        <br>
        Met vriendelijke groet,
        <br>
        Het Steddie team`
      this.sendEmail(user.email, emailSubjectUser, emailBodyUser);
    });
  }
}
